import { TripSchema } from '../schema/trip_schema.js';
import { ServiceSchema } from '../schema/service_schema.js';
import { ServiceBase } from './service_base.js';

/**
 * A service to manage checklists on the server.
 */
class ProfileService extends ServiceBase {
  /**
   * Returns user profile data.
   */
  getProfile() {
    return this.serviceRequest('get-info');
  }

  /**
   * Returns a list of co-campers you ever invited to camp with.
   */
  async getFriends() {
    let friends = await this.tripRequest('get-friends');
    return friends || [];
  }

  /**
   * Changes user name.
   */
  changeName(name) {
    return this.serviceRequest('change-name', {
      name,
    });
  }

  /**
   * Changes user name.
   */
  changePassword(data /* { old_pwd, pwd } */) {
    return this.serviceRequest('change-pwd', data);
  }

  /**
   * Changes avatar.
   */
  changeAvatar(avatar) {
    return this.serviceRequest('change-avatar', {
      avatar,
    });
  }

  getSchema(data) {
    switch (data.module) {
      case 'service':
        return ServiceSchema[data.action];
      case 'trip':
        return TripSchema[data.action];
    }
  }
}

export { ProfileService };
